var exports = {
  "k": "EmojiPickerSearchBar.module__container___c05KS0",
};

module.exports = exports;
